import React, { useState, useEffect, useRef } from "react";
import "./TermsConditionIndexLealtad.css";
import separateArchive from "../../assets/imageArchivepdf/separateArchive.png";
import separateArchiveFinal from "../../assets/imageArchivepdf/separateArchiveFinal.png";
import axios from "axios";
import Swal from "sweetalert2";
import { getTokenCookie } from "../../views/Login/cookie";
import { getCommissionDisplay } from "../../utils/commissions";

const TermsConditionIndexLealtad = ({ data }) => {
  const [signatureImageURL, setSignatureImageURL] = useState("");
  const [dataProfile, setDataProfile] = useState({});
  const [load, setLoad] = useState(true);
  const [loaderlitte, setLoaderLitte] = useState(false);
  const [dataDay, setDataDay] = useState("");
  const id = data.id;
  const downloadLinkRef = useRef(null);
  const typeDocument = "Convenio";
  const endpoint = `${process.env.REACT_APP_SIGNATURE_GET_SUPPLIER_LEALTAD}${id}`;

  useEffect(() => {
    async function fetchData() {
      const token = getTokenCookie();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GET_SUPPLIER_LEALTAD}${token}`
        );
        setDataProfile(response.data);
        setDataDay(response.data.formatDay);
        setLoad(false);
      } catch (error) {
        setLoad(false);
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DowloadPDFTerm = async (e) => {
    e.preventDefault();
    setLoaderLitte(true);
    const url = `${process.env.REACT_APP_TERMS_GET_SUPPLIER_LEALTAD}${id}`;
    try {
      const response = await axios.get(url, { responseType: "arraybuffer" });

      // Verifica que la respuesta sea exitosa (código de estado 200)
      if (response.status === 200) {
        // Obtiene el tipo de archivo del encabezado de respuesta
        let contentType = response.headers["content-type"];

        // Elimina cualquier parte adicional después del primer punto y coma (;)
        contentType = contentType.split(";")[0];

        // Obtén el tipo de archivo (extensión) a partir del tipo de contenido
        const fileExtension = contentType.split("/")[1]; // Esto obtiene la extensión, por ejemplo, "jpeg" de "image/jpeg"

        // Define el nombre del archivo
        const fileName = `${typeDocument}.${fileExtension}`;

        // Crea un blob con los datos del archivo
        const blob = new Blob([response.data], { type: contentType });

        // Crea un objeto URL para el blob
        const fileUrl = window.URL.createObjectURL(blob);

        // Crea un enlace para descargar el archivo
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;

        // Simula un clic en el enlace para iniciar la descarga
        a.click();

        // Libera el objeto URL creado
        setLoaderLitte(false);
        window.URL.revokeObjectURL(fileUrl);
      } else {
        setLoaderLitte(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error al obtener el archivo del servidor",
        });
      }
    } catch (error) {
      setLoaderLitte(false);
    }
  };

  useEffect(() => {
    const fetchSignatureImage = async () => {
      try {
        const response = await axios.get(endpoint, {
          responseType: "arraybuffer",
        }); // Especifica responseType como arraybuffer para recibir datos binarios
        const base64Image = btoa(
          String.fromCharCode.apply(null, new Uint8Array(response.data))
        ); // Convierte los datos binarios a base64
        setSignatureImageURL("data:image/png;base64," + base64Image); // Establece la URL de la imagen en formato base64
      } catch (error) {
        // Puedes manejar el error aquí según sea necesario
      }
    };

    // Llama a la función para obtener la imagen de la firma del usuario
    fetchSignatureImage();
  }, [endpoint]);

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  const supplierName = dataProfile.nameAndLastName;

  const commissionDisplays = supplierName
    ? getCommissionDisplay(supplierName)
    : [];

  return (
    <div className="alltermsconditionlealtad">
      {!load ? (
        <div className="formtermsconditionlealtad">
          <p className="tittletermsconditionlealtad">Convenio con entidad</p>
          <div className="boxconditiontermsindexlealtad">
            <div style={{ width: "100%" }}>
              <img
                style={{ width: "90%" }}
                src={separateArchive}
                alt="imgpdf"
              />
            </div>
            <p className="termsTittlelealtad">
              CONTRATO DE LOCACION DE SERVICIOS DE PROMOCION
            </p>
            <p className="textconditionalllealtad">
              Entre la ASOCIACION MUTUAL EMPLEADOS BONAERENSES (AMEBO), con
              domicilio en la calle 02 n° 825, de la ciudad y partido de La
              Plata, Provincia de Buenos Aires, representada en este acto por su
              Presidente Sr. Carlos Alberto Gaskin DNI 17.486.901, en adelante
              "LA MUTUAL", por una parte; y por la otra
              <strong>
                &nbsp;{dataProfile.nameAndLastName} C.U.I.T {dataProfile.cuit}
                &nbsp; con domicilio en Calle {dataProfile.street} N°
                {dataProfile.numberStreet} de la Localidad de&nbsp;
                {dataProfile.placeOfResidence}, Provincia de&nbsp;
                {dataProfile.province} y su correo electrónico&nbsp;
                {dataProfile.email},&nbsp;
              </strong>
              en adelante "EL PROMOTOR", convienen en celebrar el presente
              CONTRATO DE LOCACION DE SERVICIOS DE PROMOCION sujeto a las
              cláusulas enunciadas a continuación:
            </p>

            <p className="textconditionalllealtad">
              <strong>PRIMERA: OBJETO:</strong> EL PROMOTOR se compromete a
              realizar un servicio de promoción de prestaciones sociales y de
              captación de asociados, en adelante "LOS SERVICIOS", dentro de las
              pautas que se indican en el presente. LA MUTUAL podrá a su solo
              arbitrio ampliar o restringir cuantas veces lo considere necesario
              LOS SERVICIOS a promocionar en el marco del presente convenio.
            </p>
            <p className="textconditionalllealtad">
              <strong>SEGUNDA: AMBITO DE ACTUACION:</strong> El objeto
              determinado en la cláusula anterior se desarrollará en el ámbito
              territorial de la Provincia de Buenos Aires, en adelante "LA
              ZONA", pudiendo LA MUTUAL a su arbitrio, ampliarla, restringirla o
              asignarle otras cuantas veces crea conveniente a sus propios fines
              durante la vigencia del presente. EL PROMOTOR tendrá a su cargo la
              promoción mencionada en la cláusula primera, sin carácter de
              exclusividad, comprometiéndose a su vez a no realizar operaciones
              de las convenidas en este contrato con servicios que sean
              similares o competitivos con los incluidos en el objeto del
              presente acuerdo.
            </p>
            <p className="textconditionalllealtad">
              <strong> TERCERA: GESTION DE CONTROL:</strong> EL PROMOTOR
              contactara potenciales asociados de LA MUTUAL y deberá completar
              la documentación y referencias necesarias o convenientes de
              conformidad a las políticas de comercialización que fije LA MUTUAL
              y en un todo de acuerdo con las recomendaciones específicas que le
              curse LA MUTUAL durante la vigencia del presente. Asimismo EL
              PROMOTOR deberá asegurarse que la documentación de los potenciales
              asociados que envíe a LA MUTUAL como resultado de su gestión sea
              autentica, o en su caso, copias fidedignas controladas
              adecuadamente con los originales. LA MUTUAL se reserva el derecho
              de confirmar la autenticidad de la documentación aportada y
              efectuar todo tipo de controles (internos o externos) tendientes a
              confirmar la veracidad y/o exactitud. Se entenderá que EL PROMOTOR
              ha realizado dicha tarea siempre que la documentación mencionada
              se encuentre intervenida con sello y firma de EL PROMOTOR.- Como
              consecuencia de ello si se comprobara alguna irregularidad,
              falsedad, omisión culposa o dolosa, adulteración, suposición,
              supresión o interposición de personas o documentos, dará motivo al
              rechazo de la operación y aun cuando este haya sido aprobada o en
              su caso LA MUTUAL, podrá -sin requerimiento o intimación previa-
              descontar mediante débitos o compensaciones y aun con percepción
              directa o judicial, todas las sumas que hubiere generado el
              cliente y/o EL PROMOTOR con relación a las operaciones irregulares
              o defectuosas.
            </p>
            <p className="textconditionalllealtad">
              <strong> CUARTA:</strong> EL PROMOTOR se compromete a dar integro
              cumplimiento a la legislación laboral y previsional vigente, en lo
              que respecta a la generalidad de su personal y en especial,
              respecto de sus promotores directa o indirectamente afectados a la
              presentación de los servicios bajo la presente. En consecuencia,
              EL PROMOTOR se obliga a mantener a LA MUTUAL absoluta y
              permanentemente indemne (más allá de la vigencia de este contrato)
              de toda consecuencia actual o potencialmente adversa, que pudiera
              derivarse de reclamos de dependencia de EL PROMOTOR, o que aleguen
              serlo, o que pudieren provenir por omisión de aportes, retenciones
              y contribuciones, incluyendo pero no limitados a organismos
              previsionales, impositivos, sindicales u otras sociales. En virtud
              de la irrestricta garantía de indemnidad prestada precedentemente,
              EL PROMOTOR asevera y garantiza que: <br />
              <strong> a)</strong> EL PROMOTOR es una empresa con dedicación
              habitual a la prestación de promoción. <br />
              <strong>b)</strong> El personal que eventualmente dispone EL
              PROMOTOR para el cumplimiento del servicio será de exclusiva
              relación de dependencia de esta o de los canales en que esta
              designe para la comercialización, no teniendo en consecuencia
              vínculo laboral de ningún tipo con LA MUTUAL. En tal sentido, EL
              PROMOTOR se compromete a dar fiel cumplimiento a las obligaciones
              legales y convencionales respecto del personal referido, asumiendo
              la responsabilidad por eventuales inobservancias o incumplimientos
              de las mismas, como así también a notificar a la mayor brevedad
              posible, toda suma que eventualmente tuviera que abonar LA MUTUAL
              por hipotética solidaridad, como así también en igual plazo y
              forma los daños y perjuicios que por tal motivo pudiera ocasionar
              al mismo. <br />
              <strong> c)</strong>
              Por el personal interviniente en la prestación del servicio, EL
              PROMOTOR, se compromete a exigir a los canales designados para la
              comercialización de los productos, el pago de todos los rubros
              remunerativos o indemnizatorios que prescribe la legislación
              vigente en materia laboral y de seguridad social, como en materia
              de accidentes de trabajo y responsabilidad civil como así también
              a llevar los libros y registros en legal forma y contratar las
              pólizas de responsabilidad civil y por accidentes de trabajo que
              cubran la totalidad de los riesgos en la materia, respecto de todo
              su personal y de mantener actualizada las mismas. <br />
              <strong> d)</strong> Quedaran a disposición de LA MUTUAL y a su
              solo requerimiento, toda la documentación respaldatoria y obrante
              en libros sobre el personal interviniente en el servicio para la
              efectiva verificación del cumplimiento de pos compromisos
              precedentes. <br /> <strong>e)</strong> De no poder hacer
              efectivos reintegros y pagos detallados en los apartados b) y c)
              EL PROMOTOR autoriza a LA MUTUAL para que proceda a descontarle de
              las facturas que les pudiera adeudar con vencimiento inmediato y
              en las sucesivas hasta cubrir el monto pendiente más sus interese
              y demás acrecidos.
            </p>
            <p className="textconditionalllealtad">
              <strong> QUINTA: OTROS COMPROMISOS:</strong> EL PROMOTOR se
              compromete a: <br /> <strong>a)</strong> Hacer una promoción
              responsable y profesional de los servicios. <br />
              <strong>b)</strong> Evitar afectar negativamente la imagen de LA
              MUTUAL. <br /> <strong>c)</strong> Resguardar la documentación,
              formularios, datos, folletería, listados de LA MUTUAL que se
              entreguen con motivo del presente, evitando que lleguen a terceros
              no autorizados, y a devolverlos a la finalización del contrato o a
              requerimiento de LA MUTUAL. <br /> <strong>d)</strong> Mantener
              absoluta confidencialidad y reserva de toda la información que le
              proporcione LA MUTUAL o que llegue a su conocimiento en ocasión o
              con motivo del presente. En ningún caso podrá, bajo pena de
              incurrir en responsabilidad por daños y perjuicios, divulgar o
              usar los datos o información relevantes durante la ejecución de
              este contrato, para los fines al presente contrato o en beneficio
              de terceros ajenos al mismo. <br /> <strong>e)</strong> Llevar en
              forma legal la documentación y libros de comercio requeridos,
              admitiendo todo examen que a su arbitrio quiera realizar sobre los
              mismos LA MUTUAL.
              <br /> <strong>f)</strong> Informar a LA MUTUAL con la
              periodicidad, formato y contenido que esta determine sobre las
              tareas desarrolladas en cumplimiento del presente, sin perjuicio
              de la facultad de LA MUTUAL de requerir informes puntuales cuantas
              veces crea necesaria <br />. <strong>g)</strong> En cumplimiento a
              lo estipulado en la cláusula tercera del presente convenio EL
              PROMOTOR deberá dejar asentado y firmado de puño y letra de un
              apoderado con las facultades suficientes, en todas las copias de
              la documentación que envíe a LA MUTUAL la leyenda "Visto
              Original". <br />
              <strong>h)</strong> No modificar, tachar y/o enmendar la
              documentación presentada por el potencial asociado. <br />
              <strong>i)</strong> No cobrar al potencial asociado ningún tipo de
              arancel, comisión o importe por gestión o tramitación de los
              Productos. <br /> <strong>j)</strong> No garantizar al potencial
              asociado la aprobación de los Productos solicitados.
            </p>
            <p className="textconditionalllealtad">
              <strong> SEXTA: CONFIDENCIALIDAD:</strong> EL PROMOTOR se
              compromete a mantener en absoluta confidencialidad y reserva toda
              información y datos sobre: (I) asociados de LA MUTUAL, (II)
              información estratégica comercial que LA MUTUAL le facilite a EL
              PROMOTOR, (III) documentación de cualquier índole que LA MUTUAL
              proporcione a EL PROMOTOR o cualquier dato y/o información que
              llegue a su conocimiento en ocasión o con motivo del presente, por
              lo que se compromete en ocasión o con motivo del presente, por lo
              que se compromete en forma expresa y se obliga a no utilizar los
              mismos para fines ajenos al presente convenio, haciendo un
              adecuado y responsable uso, todo ello bajo pena de incurrir en
              responsabilidad por los daños y perjuicios que la indebida
              utilización de dicha información y datos le ocasione a LA MUTUAL.
              EL PROMOTOR además, se compromete a que todo tercero que tomara
              conocimiento de la información confidencial de LA MUTUAL, en razón
              del presente contrato, guardara el mismo grado de confidencialidad
              que el asumido por EL PROMOTOR en el presente convenio.
            </p>
            <p className="textconditionalllealtad">
              <strong> SEPTIMA: RETRIBUCION:</strong> EL PROMOTOR percibirá como
              única retribución por la totalidad de los servicios previstos en
              el presente: <br /> <strong>a)</strong> Para los préstamos
              personales según Ítem a) del anexo I. <br /> <strong>b)</strong>
              Será facultad privativa y discrecional de LA MUTUAL, la
              celebración de cualquier operación relativa al servicio cuya
              promoción se encomienda. El rechazo de una operación por parte de
              LA MUTUAL en ningún caso generara derecho a EL PROMOTOR a reclamar
              retribución alguna. EL PROMOTOR facturara sus servicios dentro de
              los primeros diez (10) días del mes inmediato posterior al del
              otorgamiento del servicio que sirve de base a su retribución. Los
              pagos serán efectuados por LA MUTUAL en su domicilio o mediante
              depósito en la cuenta bancaria de EL PROMOTOR, dentro de los diez
              (10) días de aprobada la factura. En caso de efectivizar los pagos
              en menor plazo, se consideraran como adelanto a cuenta. EL
              PROMOTOR como consecuencia de las actividades realizadas en el
              presente, renuncia con la mayor amplitud a solicitar la
              modificación, por cualquier vía y/o procedimiento que fuere, de la
              retribución establecida en el presente en los Anexos que se
              suscribieren, como así también a la aplicación de cualquier escala
              o normativa que posibilitare la modificación de la misma. El
              precio de la locación referido, involucra todo concepto que
              tuviere vinculación con la misma, incluyendo gastos de movilidad,
              funcionamiento, y demás que fueren indispensables para la
              promoción. Las sumas que se efectivicen en virtud de los
              porcentuales mencionados, atento a la naturaleza comercial de la
              relación, tendrán el carácter señalado precedentemente, por lo que
              las partes reconocen expresamente que el pago de las mismas, con
              la modalidad estipulada, libera a LA MUTUAL de toda otra
              obligación que se pretendiere emergente del presente contrato.
            </p>
            <p className="textconditionalllealtad">
              <strong> OCTAVA: EXCLUSIVIDAD:</strong> La celebración del
              presente no otorga derecho de exclusividad a EL PROMOTOR en
              consecuencia, LA MUTUAL podrá designar otras empresas dedicadas a
              actividades de promoción, aun en la ZONA designada a EL PROMOTOR.
              En idéntico sentido, EL PROMOTOR, declara en forma expresa que a
              la fecha las actividades indicadas en el presente constituyen su
              actividad habitual, la cual realiza a favor de distintas personas
              físicas y jurídicas, por lo cual no asume EL PROMOTOR obligaciones
              de exclusividad de ninguna índole a favor de LA MUTUAL
            </p>

            <p className="textconditionalllealtad">
              <strong>NOVENA: PUBLICIDAD:</strong> LA MUTUAL se encontrara
              facultada de efectuar publicidad por cualquier medio tendiente a
              la captación de nuevos asociados siéndole posible difundir bajo la
              forma que estime más conveniente la promoción de los servicios. EL
              PROMOTOR podrá a su costa, previa conformidad expresa y escrita de
              LA MUTUAL, realizar las campañas de marketing y promoción que
              estime como útiles para el mejor cumplimiento del presente y
              previo control por parte de LA MUTUAL.
            </p>

            <p className="textconditionalllealtad">
              <strong> DECIMA: PLAZO:</strong> La duración del presente contrato
              se fija en noventa (90) días a partir de la fecha de la firma del
              presente y se considerara renovado automáticamente y
              consecutivamente por periodos similares. No obstante ello, en
              cualquier momento, cualquiera de las partes podrá resolver el
              contrato sin expresión de causa e indemnización alguna a la
              contraparte, con el solo recaudo de preavisar fehacientemente a su
              contraria su decisión resolutoria con una anticipación no menor a
              quince (15) días corridos a la fecha en que deba hacerse efectiva
              dicha resolución.
            </p>

            <p className="textconditionalllealtad">
              <strong>DECIMA PRIMERA: INCUMPLIMIENTO:</strong> LA MUTUAL podrá
              rescindir la relación derivada del presente contrato en cualquier
              momento y sin notificación previa, ante cualquier incumplimiento
              de EL PROMOTOR respecto de las obligaciones a su cargo, como así
              mismo de que EL PROMOTOR incurra en fraude contra LA MUTUAL y/o
              contra los clientes y/o terceros, pudiendo LA MUTUAL reclamar a EL
              PROMOTOR los daños y/o perjuicios pertinentes. Asimismo, será
              causal de resolución de pleno derecho la mera presentación en
              concurso preventivo y/o restructuración de su pasivo o en pedido
              de quiebra de EL PROMOTOR. No obstante ello, la continuidad de la
              operatoria de EL PROMOTOR en estas condiciones no implica la
              aceptación tácita de LA MUTUAL quien mantiene en todo momento la
              potestad de resolver la presente en caso de ocurrencia de
              cualquiera de los supuestos mencionados precedentemente.
            </p>

            <p className="textconditionalllealtad">
              <strong>DECIMA SEGUNDA: NORMAS COMPLEMENTARIAS:</strong> Se
              consideran parte integrante del presente las normas operativas que
              sean notificadas por LA MUTUAL mediante cartas y/o circulares,
              siendo suficiente este medio de comunicación sin necesidad de otro
              tipo de notificaciones fehacientes.
            </p>

            <p className="textconditionalllealtad">
              <strong>DECIMA TERCERA: LOCACION DE SERVICIOS:</strong> Ambas
              PARTES dejan constancia que la vinculación entre las mismas se
              regirá por las normas de servicios profesionales
            </p>

            <p className="textconditionalllealtad">
              <strong>DECIMA CUARTA: IMPUESTOS:</strong> En caso de corresponder
              por la suscripción del presente el pago de impuestos, sean estos,
              nacionales, provinciales y/o locales, u otro gravamen que en el
              futuro sean aplicables al contrato, los mismos serán conceptos a
              cargo de EL PROMOTOR y serán descontados por LA MUTUAL, de la
              primera facturación posterior a su efectivo desembolso.
            </p>

            <p className="textconditionalllealtad">
              <strong>
                DECIMA QUINTA: RESCISION DE CONTRATO FIRMADOS CON ANTERIORIDAD
                AL PRESENTE:
              </strong>
              Las PARTES de común acuerdo convienen dejar sin efecto la
              totalidad de los Contratos y Anexos suscriptos entre las PARTES
              con anterioridad al presente contrato, sin que ello genere derecho
              de indemnización alguna.
            </p>

            <p className="textconditionalllealtad">
              <strong>DECIMA SEXTA: DOMICILIO Y JURISDICCION:</strong> Para
              todos los efectos del presente las PARTES constituyen domicilios
              en los indicados al comienzo, donde serán válidas todas las
              notificaciones, tanto las judiciales como extrajudiciales,
              sometiéndose a la jurisdicción de los tribunales ordinarios en lo
              comercial de la Ciudad de La Plata provincia de Buenos Aires, con
              renuncia expresa a cualquier otro fuero o jurisdicción que pudiera
              corresponder.-
            </p>

            <p className="textconditionalllealtad">
              De conformidad se firman dos ejemplares de un mismo tenor y a un
              solo efecto en la ciudad de La Plata, Provincia de Buenos Aires, a
              los {dataProfile.SupplierSignature.dayOfMonth}
            </p>

            <p
              style={{
                textAlign: "center",
                letterSpacing: "1px",
                marginTop: "25px",
                fontWeight: 600,
                color: "#3d3d3d",
                fontFamily: "fangsong",
                lineHeight: "25px",
              }}
            >
              Tel: 221 4221032 / e-mail: mutualamebo@hotmail.com
            </p>

            <div style={{ width: "100%" }}>
              <img
                style={{ width: "90%" }}
                src={separateArchiveFinal}
                alt="imgpdf"
              />
            </div>

            <p className="textconditionalllealtad">
              Entre la ASOCIACION MUTUAL EMPLEADOS BONAERENSES (AMEBO) y LEALTAD
              ASOCIACION MUTUAL (LEALTAD), se firmó un convenio Inter-Mutual,
              para prestar el servicio de gestión de préstamos, RES 1481/09
              INAES. El mismo conlleva que, la aprobación de los contratos
              firmados anteriormente, tengan plenavigencia y, se adicione a cada
              uno de ellos este nuevo anexo 01, explicitando que la
              comercialización de préstamos de ambas entidades, se
              complementaran para generar una nueva y única escala de comisiones
              indexada al Salario Mínimo, Vital y Móvil.
            </p>

            <p className="textconditionalllealtad">
              Del contrato de locación de servicios de promoción entre
              ASOCIACION MUTUAL EMPLEADOS BONAERENSES, LEALTAD ASOCIACIÓN
              MUTUAL, y
              <strong>
                &nbsp;&nbsp;{dataProfile.nameAndLastName} C.U.I.T&nbsp;
                {dataProfile.cuit} con domicilio en Calle {dataProfile.street}
                &nbsp; N°{dataProfile.numberStreet} de la Localidad de&nbsp;
                {dataProfile.placeOfResidence}, Provincia de&nbsp;
                {dataProfile.province} y su correo electrónico&nbsp;
                {dataProfile.email}
              </strong>
            </p>

            {supplierName && (
              <>
                <p className="textconditionall">Retribuciones:</p>
                {commissionDisplays.map((display, index) => (
                  <p key={index} className="textconditionall">
                    {display}
                  </p>
                ))}
              </>
            )}

            <p className="textconditionalllealtad">
              Las partes de común acuerdo pactaran nuevo esquema de
              retribuciones si la circunstancia operacional así lo justifique.
              La Plata, {dataDay}
            </p>

            <p
              style={{
                textAlign: "center",
                letterSpacing: "1px",
                marginTop: "25px",
                fontWeight: 600,
                color: "#3d3d3d",
                fontFamily: "fangsong",
                lineHeight: "25px",
              }}
            >
              Tel: 221 4221032 / e-mail: mutualamebo@hotmail.com
            </p>
          </div>

          <div className="boxsignaturelealtad">
            {signatureImageURL && (
              <img
                className="signatureiamgelealtad"
                src={signatureImageURL}
                alt="Firma del usuario"
              />
            )}
          </div>

          <div>
            {!loaderlitte ? (
              <button
                className="buttonprovprofilesignaturelealtad"
                onClick={(e) => DowloadPDFTerm(e)}
                ref={downloadLinkRef}
              >
                Descargar
              </button>
            ) : (
              <span class="loaderlittelealtad"></span>
            )}
          </div>
        </div>
      ) : (
        <div className="loaderlealtad"></div>
      )}
    </div>
  );
};

export default TermsConditionIndexLealtad;
